'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash.curry');

var _lodash2 = _interopRequireDefault(_lodash);

var _get = require('./get');

var _get2 = _interopRequireDefault(_get);

var _fromTime = require('./fromTime');

var _fromTime2 = _interopRequireDefault(_fromTime);

var _constants = require('./helpers/constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//@flow
var setWeek = function setWeek(value, date) {
  var currentWeek = (0, _get2.default)('week', date);
  var diffWeeks = value - currentWeek;
  var diffTime = _constants.DATE_UNITS.weeks * diffWeeks;
  var changedDate = new Date(date.getTime() + diffTime);
  date.setUTCMonth(changedDate.getUTCMonth());
  date.setUTCDate(changedDate.getUTCDate());
};

var setters = {
  'milliseconds': function milliseconds(value, date) {
    return date.setUTCMilliseconds(value);
  },
  'seconds': function seconds(value, date) {
    return date.setUTCSeconds(value);
  },
  'minutes': function minutes(value, date) {
    return date.setUTCMinutes(value);
  },
  'hours': function hours(value, date) {
    return date.setUTCHours(value);
  },
  'date': function date(value, _date) {
    return _date.setUTCDate(value);
  },
  'week': setWeek,
  'month': function month(value, date) {
    return date.setUTCMonth(value - 1);
  },
  'year': function year(value, date) {
    return date.setUTCFullYear(value);
  }
};

exports.default = (0, _lodash2.default)(function (step, value, date) {
  if (!setters.hasOwnProperty(step)) return new Date('invalid');

  var clone = (0, _fromTime2.default)(date.getTime());

  setters[step](value, clone);

  return (0, _get2.default)(step, clone) === value ? clone : new Date('invalid');
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/date-fp/build/set.js
// module id = 1401
// module chunks = 0 1 2 3 4 5 7 8 9